import Image from "next/image";
import Link from "next/link";
import React, { useContext, useEffect, useState } from "react";
import AppContext from "../../../../services/app-context-services";
import { ROUTES } from "../../../../services/router-services";
import style from "./desktopSliderCard.module.scss";
import { trackEvent } from "../../../../services/ga-services";
import { Product } from "../../../../models/home-rows";

type SwiperProps = {
  product: Product;
};


export const DesktopSliderCard = ({ product }: SwiperProps) => {
  const {isIntlUser, setShowLoginPopup} = useContext(AppContext);

  const [url, setUrl] = useState("");

  const checkUserStatus = e => {
    trackEvent("Home Item", product?.name, product?.id.toString() ?? "");
    if (isIntlUser) {
      e.preventDefault();
      e.stopPropagation();
      setShowLoginPopup(true);
    }
  };
  useEffect(() => {
    if (!product?.id || isIntlUser) return;
    setUrl(ROUTES.product(product));
  }, [product?.product_type, product?.id, product?.name_english]);

  return (
    <>
      {isIntlUser ? (
        <div onClick={checkUserStatus}>
          <div className={style.card}>
            {product?.avatar && (
              <Image src={product?.avatar?.xhdpi} height={400} width={272} />
            )}
            <div className={style.title}>
              <span>{product?.name}</span>
            </div>
            {/* <div className={style.cardDetails}>
                <span>{slide.category_model[0].title} ـ ۱۴۰۲</span>
                <span>
                  <Image src={like} height={32} width={32} />
                  {slide.rank}
                </span>
                <span>IMDb {slide.rank}</span>
              </div> */}
          </div>
        </div>
      ) : (
        <Link href={url} prefetch={false}>
          <div className={style.card}>
            {product?.avatar && (
              <Image src={product?.avatar?.xhdpi} height={400} width={272} />
            )}

            <div className={style.title}>
              <span>{product?.name}</span>
            </div>
            {/* <div className={style.cardDetails}>
                <span>{slide.category_model[0].title} ـ ۱۴۰۲</span>
                <span>
                  <Image src={like} height={32} width={32} />
                  {slide.rank}
                </span>
                <span>IMDb {slide.rank}</span>
              </div> */}
          </div>
        </Link>
      )}
    </>
  );
};
